import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ContactPage } from './pages/ContactPage';
import { BlogListPage } from './pages/blog/BlogListPage';
import { GapAnalysisBlog } from './pages/blog/GapAnalysisBlog';
import { ExportMarketsBlog } from './pages/blog/ExportMarketsBlog';
import { TimeToMarketBlog } from './pages/blog/TimeToMarketBlog';
import { ArtworkComplianceBlog } from './pages/blog/ArtworkComplianceBlog';
import { BrandingBlog } from './pages/blog/BrandingBlog';
import { TrialAndErrorBlog } from './pages/blog/TrialAndErrorBlog';
import { LaunchProgramPage } from './pages/LaunchProgramPage';
import { SuccessPacksPage } from './pages/SuccessPacksPage';
import { CountriesPage } from './pages/CountriesPage';
import { GroundworkPackPage } from './pages/success-packs/GroundworkPackPage';
import { GapAnalysisPackPage } from './pages/success-packs/GapAnalysisPackPage';
import { RegistrationDossierPackPage } from './pages/success-packs/RegistrationDossierPackPage';
import { LifecyclePackPage } from './pages/success-packs/LifecyclePackPage';
import { SourcingPartnershipPackPage } from './pages/success-packs/SourcingPartnershipPackPage';
import { RetainerPlanPage } from './pages/RetainerPlanPage';
import { AfricaRegionPage } from './pages/regions/AfricaRegionPage';
import { AsiaRegionPage } from './pages/regions/AsiaRegionPage';
import { GCCRegionPage } from './pages/regions/GCCRegionPage';
import { LATAMRegionPage } from './pages/regions/LATAMRegionPage';
import { CambodiaPage } from './pages/countries/CambodiaPage';
import { KenyaPage } from './pages/countries/KenyaPage';
import { TanzaniaPage } from './pages/countries/TanzaniaPage';
import { UgandaPage } from './pages/countries/UgandaPage';
import { BeninPage } from './pages/countries/BeninPage';
import { SenegalPage } from './pages/countries/SenegalPage';
import { TogoPage } from './pages/countries/TogoPage';
import { NigeriaPage } from './pages/countries/NigeriaPage';
import { MozambiquePage } from './pages/countries/MozambiquePage';
import { GhanaPage } from './pages/countries/GhanaPage';
import { MauritiusPage } from './pages/countries/MauritiusPage';
import { MalaysiaPage } from './pages/countries/MalaysiaPage';
import { MyanmarPage } from './pages/countries/MyanmarPage';
import { SriLankaPage } from './pages/countries/SriLankaPage';
import { NepalPage } from './pages/countries/NepalPage';
import { BangladeshPage } from './pages/countries/BangladeshPage';
import { BhutanPage } from './pages/countries/BhutanPage';
import { MaldivesPage } from './pages/countries/MaldivesPage';
import { BahrainPage } from './pages/countries/BahrainPage';
import { KuwaitPage } from './pages/countries/KuwaitPage';
import { OmanPage } from './pages/countries/OmanPage';
import { QatarPage } from './pages/countries/QatarPage';
import { SaudiArabiaPage } from './pages/countries/SaudiArabiaPage';
import { UAEPage } from './pages/countries/UAEPage';
import { MexicoPage } from './pages/countries/MexicoPage';
import { ColombiaPage } from './pages/countries/ColombiaPage';
import { PeruPage } from './pages/countries/PeruPage';
import { ChilePage } from './pages/countries/ChilePage';
import { DominicanRepublicPage } from './pages/countries/DominicanRepublicPage';
import { PanamaPage } from './pages/countries/PanamaPage';
import { CostaRicaPage } from './pages/countries/CostaRicaPage';
import { ParaguayPage } from './pages/countries/ParaguayPage';
import { UruguayPage } from './pages/countries/UruguayPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ScrollToTop } from './components/ScrollToTop';

function App() {
  return (
    <div className="App" style={{ backgroundColor: '#F0E0D0', minHeight: '100vh', overflowX: 'hidden', maxWidth: '100vw' }}>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/gap-analysis-saves-dossier-rejections" element={<GapAnalysisBlog />} />
          <Route path="/blog/choose-right-export-markets" element={<ExportMarketsBlog />} />
          <Route path="/blog/reduce-time-to-market-exports" element={<TimeToMarketBlog />} />
          <Route path="/blog/pharma-artwork-compliance-checklist" element={<ArtworkComplianceBlog />} />
          <Route path="/blog/country-specific-branding-product-name" element={<BrandingBlog />} />
          <Route path="/blog/smes-avoid-trial-and-error-regulatory" element={<TrialAndErrorBlog />} />
          <Route path="/launch-program" element={<LaunchProgramPage />} />
          <Route path="/success-packs" element={<SuccessPacksPage />} />
          <Route path="/success-packs/sourcing-partnership-pack" element={<SourcingPartnershipPackPage />} />
          <Route path="/success-packs/groundwork-pack" element={<GroundworkPackPage />} />
          <Route path="/success-packs/gap-analysis-pack" element={<GapAnalysisPackPage />} />
          <Route path="/success-packs/registration-dossier-pack" element={<RegistrationDossierPackPage />} />
          <Route path="/success-packs/lifecycle-pack" element={<LifecyclePackPage />} />
          <Route path="/retainer" element={<RetainerPlanPage />} />
          <Route path="/retainer-plan" element={<RetainerPlanPage />} />
          <Route path="/countries" element={<CountriesPage />} />
          <Route path="/regions/africa" element={<AfricaRegionPage />} />
          <Route path="/regions/asia" element={<AsiaRegionPage />} />
          <Route path="/regions/gcc" element={<GCCRegionPage />} />
          <Route path="/regions/latam" element={<LATAMRegionPage />} />
          <Route path="/country/cambodia" element={<CambodiaPage />} />
          <Route path="/country/kenya" element={<KenyaPage />} />
          <Route path="/country/tanzania" element={<TanzaniaPage />} />
          <Route path="/country/uganda-pharma-nutra-registration" element={<UgandaPage />} />
          <Route path="/country/benin-pharma-nutra-registration" element={<BeninPage />} />
          <Route path="/country/senegal-pharma-nutra-registration" element={<SenegalPage />} />
          <Route path="/country/togo-pharma-nutra-registration" element={<TogoPage />} />
          <Route path="/country/nigeria-pharma-nutra-registration" element={<NigeriaPage />} />
          <Route path="/country/mozambique-pharma-nutra-registration" element={<MozambiquePage />} />
          <Route path="/country/ghana-pharma-nutra-registration" element={<GhanaPage />} />
          <Route path="/country/mauritius-pharma-nutra-registration" element={<MauritiusPage />} />
          <Route path="/country/malaysia-pharma-nutra-registration" element={<MalaysiaPage />} />
          <Route path="/country/myanmar-pharma-nutra-registration" element={<MyanmarPage />} />
          <Route path="/country/sri-lanka-pharma-nutra-registration" element={<SriLankaPage />} />
          <Route path="/country/nepal-pharma-nutra-registration" element={<NepalPage />} />
          <Route path="/country/bangladesh-pharma-nutra-registration" element={<BangladeshPage />} />
          <Route path="/country/bhutan-pharma-nutra-registration" element={<BhutanPage />} />
          <Route path="/country/maldives-pharma-nutra-registration" element={<MaldivesPage />} />
          <Route path="/country/bahrain-pharma-nutra-registration" element={<BahrainPage />} />
          <Route path="/country/kuwait" element={<KuwaitPage />} />
          <Route path="/country/oman-pharma-nutra-registration" element={<OmanPage />} />
          <Route path="/country/qatar-pharma-nutra-registration" element={<QatarPage />} />
          <Route path="/country/saudi-arabia-pharma-nutra-registration" element={<SaudiArabiaPage />} />
          <Route path="/country/united-arab-emirates-pharma-nutra-registration" element={<UAEPage />} />
          <Route path="/country/mexico-pharma-nutra-registration" element={<MexicoPage />} />
          <Route path="/country/colombia-pharma-nutra-registration" element={<ColombiaPage />} />
          <Route path="/country/peru-pharma-nutra-registration" element={<PeruPage />} />
          <Route path="/country/chile-pharma-nutra-registration" element={<ChilePage />} />
          <Route path="/country/dominican-republic-pharma-nutra-registration" element={<DominicanRepublicPage />} />
          <Route path="/country/panama-pharma-nutra-registration" element={<PanamaPage />} />
          <Route path="/country/costa-rica-pharma-nutra-registration" element={<CostaRicaPage />} />
          <Route path="/country/paraguay-pharma-nutra-registration" element={<ParaguayPage />} />
          <Route path="/country/uruguay-pharma-nutra-registration" element={<UruguayPage />} />
          {/* 404 Catch-all route - must be last */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;